<template>
  <div
    class="dropdown is-fullwidth"
    :class="alinhamentoAoAbrir"
    style="min-width:100%;"
    :id="`dropdown-${identificador}`"
    @click.stop="(event) => _showDropdownOptions(event)"
  >
    <div class="dropdown-trigger is-fullwidth" style="min-width:100%;">
      <button class="button is-fullwidth" :class="classCor" :disabled="disabled" aria-haspopup="true" aria-controls="dropdown-menu6">
        <span class="icon is-small" v-if="_showIconeNaEsquerda()">
          <i class="mdi" :class="classIconEsquerda" aria-hidden="true"></i>
        </span>
        <span>{{ nome }}</span>
        <slot name="nomeDropdown"/>
        <span class="icon is-small">
          <i class="mdi mdi-menu-down mdi-24px" aria-hidden="true"></i>
        </span>
      </button>
    </div>
    <div class="dropdown-menu is-fullwidth" role="menu" style="min-width:100%;">
      <div class="dropdown-content is-pulled-left is-fullwidth ml-6" style="min-width:100%;">
        <button v-for="(option, index) in btnOptions" :key="index"
          class="dropdown-item button is-small"
          type="button"
          :id="option.id"
          @click="option.acao"
        >
          <i class="mdi" :class="option.icon" aria-hidden="true"></i>
          {{ option.nome }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  nome: "TrfDropdownButton",
  props: {
    nome: String,
    classIconEsquerda: String,
    identificador: String,
    btnOptions: Array,
    classCor: {
      type: String,
      default: 'is-primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    alinhamentoAoAbrir: {
      type: String,
      default: 'is-left'
    }
  },
  data() {
    return {

    };
  },
  methods: {
    _showIconeNaEsquerda() {
      return this.classIconEsquerda ? true : false;
    },
    _showDropdownOptions(event) {
      if (this.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      let isActive = document.getElementById(`dropdown-${this.identificador}`).classList.contains("is-active");
      this._closeDropdownsOptions();

      if (isActive) return;

      document.getElementById(`dropdown-${this.identificador}`).classList.toggle("is-active");
    },

    _closeDropdownsOptions(event) {
      if (event) event.stopPropagation();
      const dropdowns = document.querySelectorAll(`.dropdown.${this.alinhamentoAoAbrir}.is-active`);

      for (let dropdown of dropdowns) {
        dropdown.classList.remove("is-active");
      }
    },

    _onClickDocument(event) {
      const dropdownActive = document.querySelector(`.dropdown.${this.alinhamentoAoAbrir}.is-active`);
      if (dropdownActive == null) return;
      const isClickInsideElement = dropdownActive.contains(event.target);
      if (isClickInsideElement) return;
      this._closeDropdownsOptions();
    },
  },
  mounted() {
    document.addEventListener("click", this._onClickDocument);
  },

  deactivated() {
    document.removeEventListener("click", this._onClickDocument);
  },
};
</script>

<style lang="scss" scoped>
.dropdown-content > button {
  border: none;
  font-size: 14px;
  padding-right: 2rem;
}
</style>
